import React from "react"
import Rating from "@/components/svg/Rating"

const CustomerRating = ({
  logo,
  row = false,
  comment,
  cite,
  rating,
  center = true,
}) => {
  return (
    <article
      className={`customer-ratings__column ${row ? "row" : ""} ${
        !center ? "start-xs" : ""
      }`}
    >
      {logo && <div className="mr-4">{logo}</div>}
      <div>
        <Rating rating={rating} />
        {comment && <h4 className={`customer-ratings__comment ${center ? "col-xs-10 " : ""}`}>“{comment}“</h4>}
        <p className="customer-ratings__cite">{cite}</p>
      </div>
    </article>
  )
}

export default CustomerRating
